import React, { useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import MoreVert from '@mui/icons-material/MoreVert';

import { GBENSContext } from '../GBENSContainer';

import { TraderDetailsModal } from '../Modals/ConsignmentModals';

import Row from './_Row';

const NeenorAutocomplete = ({
  name,
  screen,
  modal,
  placeholder,
  toolTip,
  rowProps,
  options = [],
  consignment,
  disabled,
}) => {
  const { data, updateData, errors, currentConsignment, currentConsignmentErrors, selectNeenor } =
    useContext(GBENSContext);

  const filter = createFilterOptions();

  const [inputValue, setInputValue] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [defaultNeeNorDetails, setDefaultNeeNorDetails] = useState(null);

  const valueToUse = useMemo(() => {
    const currentValue = consignment ? currentConsignment?.[modal] : data?.[screen]?.[modal];
    if (currentValue && Object.keys(currentValue).length > 0) {
      return currentValue;
    }
    return null;
  }, [data, currentConsignment]);

  const selectValue = (newValue) => {
    if (consignment) {
      selectNeenor(modal, newValue);
    } else {
      updateData({ target: { value: newValue } }, screen, modal, null);
    }
  };

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton onClick={() => setModalOpen(true)} edge="end">
        <MoreVert />
      </IconButton>
    </InputAdornment>
  );

  return (
    <>
      <TraderDetailsModal
        open={modalOpen}
        setOpen={setModalOpen}
        defaultValues={defaultNeeNorDetails}
        setDefaultValues={setDefaultNeeNorDetails}
        modal={modal}
        screen={screen}
        consignment={consignment}
      />
      <Row
        warning={screen ? errors?.[screen]?.[modal] : currentConsignmentErrors?.[modal]}
        name={name}
        toolTip={toolTip}
        rowProps={rowProps}
        component={
          <FormControl variant="standard" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Autocomplete
              variant="standard"
              fullWidth
              inputValue={inputValue}
              value={valueToUse}
              onInputChange={(_e, v) => setInputValue(v)}
              options={options}
              disabled={disabled}
              onChange={(_event, newValue) => {
                if (newValue?.inputValue) {
                  if (/^\D{2}\d+/.test(newValue.inputValue)) setDefaultNeeNorDetails({ eori: newValue.inputValue });
                  else setDefaultNeeNorDetails({ companyName: newValue.inputValue });
                  setModalOpen(true);
                } else {
                  setDefaultNeeNorDetails(null);
                  selectValue(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some(
                  (option) => inputValue === option.companyName || inputValue === option.eori
                );
                if (inputValue !== '' && !isExisting) {
                  console.log('Not existing pushing ' + inputValue);
                  filtered.push({
                    inputValue,
                    add: `Add "${inputValue}"`,
                  });
                }

                return filtered;
              }}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }

                // Regular option
                return `${option.companyName} ${option.eori ? `(${option.eori})` : ''}`;
              }}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    {option.add ? option.add : `${option.companyName} ${option.eori ? `(${option.eori})` : ''}`}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  slotProps={{
                    inputLabel: {
                      shrink: false,
                      style: { color: '#00857d', margin: 0, padding: 0, fontSize: 15, fontStyle: 'italic' },
                    },
                  }}
                  {...params}
                  label={!inputValue || inputValue === '' ? placeholder : ''}
                />
              )}
            />
            {endAdornment}
          </FormControl>
        }
      />
    </>
  );
};
NeenorAutocomplete.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  modal: PropTypes.string,
  toolTip: PropTypes.string,
  rowProps: PropTypes.object,
};

export default NeenorAutocomplete;
